import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL } from "../../shared/constant";
import Select from "react-select";
import axios from "axios";

const AddCustomer = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [stateDrp, setStateDrpData] = useState([]);
  const [cityDrp, setCityDrpData] = useState([]);
  const [formValue, setFormValue] = useState({
    id: null,
    name: "",
    contact_no: "",
    email: "",
    city_id: "",
    state_id: "",
    pincode: "",
  });

  const styles = {
    menu: (baseStyles) => ({ ...baseStyles, marginTop: 2 }),
  };

  const resetForm = () => {
    setFormValue({ id: null, name: "", contact_no: "", email: "", city_id: "", state_id: "", pincode: "" });
  };

  const getStateDrpData = () => {
    axios.post(API_URL.STATE_LIST, { country_id: 101 }).then((res) => {
      setStateDrpData(
        res.data.data.map((s) => ({ label: s.name, value: s.id }))
      );
    });
  };

  const getCityDrpData = () => {
    if (!formValue.state_id) return;
    axios.post(API_URL.CITY_LIST, { state_id: formValue.state_id }).then((res) => {
      setCityDrpData(
        res.data.data.map((c) => ({ label: c.name, value: c.id }))
      );
    });
  };

  const onEdit = () => {
    axios.post(API_URL.DEALER_USERS_SHOW, { id }).then((res) => {
      if (res.data.status === 1) {
        const d = res.data.data;
        setFormValue({
          id: d.id,
          name: d.name || "",
          contact_no: d.contact_no || "",
          email: d.email || "",
          city_id: d.city_id || "",
          state_id: d.state_id || "",
          pincode: d.pincode || "",
        });
      }
    });
  };

  const saveCustomer = () => {
    if (!formValue.name || !formValue.contact_no || !formValue.city_id || !formValue.state_id) return;

    const url = id ? API_URL.DEALER_USERS_UPDATE : API_URL.DEALER_USERS_STORE;
    axios.post(url, formValue).then((res) => {
      if (res.data.status === 1) {
        if (id) {
          toast.success("Updated", { autoClose: 3000 });
          setTimeout(() => navigate("/customers", { replace: true }), 100);
        } else {
          resetForm();
          toast.success("Saved", { autoClose: 3000 });
        }
      } else {
        toast.error(res.data.data, { autoClose: 3000 });
      }
    });
  };

  const isValidForm = () =>
    formValue.name && formValue.contact_no && formValue.city_id && formValue.state_id;

  useEffect(() => {
    getCityDrpData();
  }, [formValue.state_id]);

  useEffect(() => {
    id && onEdit();
  }, [id]);

  useEffect(() => {
    getStateDrpData();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>{id ? "Edit" : "Add"} Customer</h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center justify-content-end">
            <Link to="/customers" className="btn btn-secondary">
              <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
            </Link>
          </div>
        </div>
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Name<span className="text-danger">*</span></label>
                      <input
                        type="text"
                        value={formValue.name}
                        onChange={(e) => setFormValue({ ...formValue, name: e.target.value })}
                        className="form-control"
                        placeholder="Enter Name"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Contact Number<span className="text-danger">*</span></label>
                      <input
                        type="text"
                        value={formValue.contact_no}
                        onChange={(e) => setFormValue({ ...formValue, contact_no: e.target.value })}
                        className="form-control"
                        placeholder="Contact Number"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="text"
                        value={formValue.email}
                        onChange={(e) => setFormValue({ ...formValue, email: e.target.value })}
                        className="form-control"
                        placeholder="Email"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>State<span className="text-danger">*</span></label>
                      <Select
                        options={stateDrp}
                        value={stateDrp.find((r) => r.value == formValue.state_id) || null}
                        styles={styles}
                        onChange={(e) => setFormValue({ ...formValue, state_id: e.value, city_id: "" })}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>City<span className="text-danger">*</span></label>
                      <Select
                        options={cityDrp}
                        value={cityDrp.find((r) => r.value == formValue.city_id) || null}
                        styles={styles}
                        onChange={(e) => setFormValue({ ...formValue, city_id: e.value })}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Pincode</label>
                      <input
                        type="text"
                        value={formValue.pincode}
                        onChange={(e) => setFormValue({ ...formValue, pincode: e.target.value })}
                        className="form-control"
                        placeholder="Pincode"
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 mt-2">
                    <div className="form-group text-right">
                      <button
                        type="submit"
                        onClick={saveCustomer}
                        disabled={!isValidForm()}
                        className="btn btn-primary"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCustomer;
